import React, {useState, useEffect} from 'react'

import classes from './Rays.module.css'

const Rays = ({ className }) => {

  return (
    <div className={`${classes.Rays} ${className}`}>
    </div>
  );
};

export default Rays;
